const MUNICIPALITIES = {
  Culebra: 25,
  Vieques: 75,
};

export default MUNICIPALITIES;
